{
  "schemaVersion": "1.0.0",
  "scenarioId": "happy-path",
  "payload": {
    "records": [
      {
        "id": 1,
        "full_name": "Alex Torres",
        "email": "alex.torres@example.com",
        "phone": "+34 611 222 333",
        "signup_date": "2024-01-15",
        "ip_address": "192.168.1.10",
        "plan": "pro",
        "is_active": true,
        "notes": "Prefiere contacto por email."
      },
      {
        "id": 2,
        "full_name": "Marta Ruiz",
        "email": "marta.ruiz@example.com",
        "phone": "+34 622 333 444",
        "signup_date": "2024-02-03",
        "ip_address": "192.168.1.11",
        "plan": "free",
        "is_active": false,
        "notes": "Solicitó baja el 2024-05-01."
      },
      {
        "id": 3,
        "full_name": "Diego Fernández",
        "email": "diego.fernandez@example.com",
        "phone": "+34 633 444 555",
        "signup_date": "2024-01-22",
        "ip_address": "192.168.1.12",
        "plan": "pro",
        "is_active": true,
        "notes": "Referido por Marta Ruiz."
      },
      {
        "id": 4,
        "full_name": "Laura Gómez",
        "email": "laura.gomez@example.com",
        "phone": "+34 644 555 666",
        "signup_date": "2024-03-11",
        "ip_address": "192.168.1.13",
        "plan": "team",
        "is_active": true,
        "notes": "Administradora de la cuenta de equipo."
      },
      {
        "id": 5,
        "full_name": "Iván Molina",
        "email": "ivan.molina@example.com",
        "phone": "+34 655 666 777",
        "signup_date": "2024-04-02",
        "ip_address": "192.168.1.14",
        "plan": "free",
        "is_active": true,
        "notes": "Consulta pendiente sobre facturación."
      },
      {
        "id": 6,
        "full_name": "Carla Núñez",
        "email": "carla.nunez@example.com",
        "phone": "+34 666 777 888",
        "signup_date": "2024-02-19",
        "ip_address": "192.168.1.15",
        "plan": "pro",
        "is_active": false,
        "notes": "Migró desde plan free en marzo."
      },
      {
        "id": 7,
        "full_name": "Bruno Serra",
        "email": "bruno.serra@example.com",
        "phone": "+34 677 888 999",
        "signup_date": "2024-05-07",
        "ip_address": "192.168.1.16",
        "plan": "team",
        "is_active": true,
        "notes": "Contacto técnico principal del equipo."
      },
      {
        "id": 8,
        "full_name": "Nadia Ortiz",
        "email": "nadia.ortiz@example.com",
        "phone": "+34 688 999 000",
        "signup_date": "2024-03-28",
        "ip_address": "192.168.1.17",
        "plan": "free",
        "is_active": false,
        "notes": "Sin actividad desde abril de 2024."
      }
    ],
    "rules": [
      { "field": "full_name", "strategy": "randomize" },
      { "field": "email", "strategy": "hash" }
    ]
  },
  "options": { "deterministic": true }
}
